import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import withSource from '../../../../../hocs/source-scoll'
import { Iconfont } from '../../../../../components/icon/iconfont'

export default withSource(props => {
    useStyles(classes)
    const { icon, backgroundColor, innerRef, sensors, onClose } = props
    return <div
        ref={innerRef}
        data-position={sensors?.resource_position}
        data-type={sensors?.resource_type}
        data-content={sensors?.resource_content}
        data-title={sensors?.resourcepage_title}
        className={classes.Container}
        style={{
            backgroundColor: backgroundColor
        }}>
        {
            icon && <div className={classes.Icon}>
                {icon}
            </div>
        }
        <div className={classes.Content}>
            {
                props.children
            }
        </div>
        {
            onClose && <Iconfont onClick={onClose} className={classes.Close}>&#xe6af;</Iconfont>
        }
    </div>
})